export default __webpack_public_path__ + "maps-overview-circle-layer-960-940e7385431467c958e563d247dd66d1.webp";